import { Client } from "@planningcenter/api-client"
import { validate as uuidValidate } from "uuid"

const checkInsClient = new Client({
  app: "check-ins",
  version: "2019-07-17"
})

// Sessions
export const getSessions = integrationId =>
  checkInsClient.get({
    url: `/app_events/${integrationId}/app_event_sessions`,
    data: {
      fields: { AppEventSession: "id,shows_at,hides_at" },
      order: "shows_at",
      per_page: 20
    }
  })

export const sessionsParams = sessions => ({
  app_event_sessions_attributes: sessions.map(s => {
    if (uuidValidate(s?.id)) delete s.id
    return {
      id: s?.id,
      shows_at: s.showsAt,
      hides_at: s.hidesAt,
      _destroy: s?._destroy
    }
  })
})

export const labelParams = labels => {
  const labelsAttributes = labels.map(l => {
    if (uuidValidate(l?.id)) delete l.id
    return {
      id: l?.id,
      conditional_types: l?.conditionalTypes,
      label_id: l?.labelId,
      _destroy: l?._destroy
    }
  })

  return { app_event_labels_attributes: labelsAttributes }
}

// Labels
export const getLabels = () =>
  checkInsClient.get({
    url: "/labels",
    data: { fields: { Label: "name,prints_for" } }
  })
